// Import necessary React hooks and components
import { useState } from "react";
// Import necessary Material-UI components
import { Button } from "@mui/material";
// Import custom components
import {
  SampleRequestSampleControlAddSupplierDetailsModal,
  SampleRequestSampleControlAddReceiverDetailsModal,
  AddNewItemERPCodeDialog,
} from "./";

/**
 * AddSampleDetails component for adding sample details for sample control team
 * @param {Object} props - Component props including modal state, data, and callbacks.
 */
export function AddSampleDetails({
  supplier,
  sampleRequestID,
  sampleItemID,
  supplierValues,
  setReloadData,
}) {
  // State for controlling the visibility of the Add Supplier Details Modal
  const [openAddSupplierDetailsModal, setOpenAddSupplierDetailsModal] =
    useState(false);
  // Function to open the Add Supplier Details Modal
  const handleOpenAddSupplierDetailsModal = () => {
    setOpenAddSupplierDetailsModal(true);
  };
  // State for controlling the visibility of the Add Receiver Details Modal
  const [openAddReceiverDetailsModal, setOpenAddReceiverDetailsModal] =
    useState(false);
  // Function to open the Add Receiver Details Modal
  const handleOpenAddReceiverDetailsModal = () => {
    setOpenAddReceiverDetailsModal(true);
  };

  // State for controlling the visibility of the Add New Item Code Dialog
  const [openAddNewItemCodeDialog, setOpenAddNewItemCodeDialog] =
    useState(false);
  // Function to open the Add new Item Code Dialog
  const handleOpenAddNewItemCodeDialog = () => {
    setOpenAddNewItemCodeDialog(true);
  };
  return (
    <div>
      {/* Conditionally render the Add Sample Details button if the supplier's receipt date is pending */}
      {supplier.receiptDate.toLowerCase() === "pending" && (
        <div>
          <Button
            size="small"
            variant="contained"
            sx={{
              padding: "10px 20px",
              mb: "20px",
              fontSize: "14px",
              backgroundColor: "#c7ab79",
              "&:hover": {
                backgroundColor: "#c4943f",
              },
              textTransform: "capitalize",
            }}
            onClick={() => handleOpenAddSupplierDetailsModal()}
          >
            Add Sample Details
          </Button>
          {/* Conditionally render the Add Supplier Details Modal based on its open state */}
          {openAddSupplierDetailsModal && (
            <SampleRequestSampleControlAddSupplierDetailsModal
              open={openAddSupplierDetailsModal}
              setOpen={setOpenAddSupplierDetailsModal}
              data={supplier}
              sampleRequestID={sampleRequestID}
              sampleItemID={sampleItemID}
              supplierValues={supplierValues}
              setReloadData={setReloadData}
            />
          )}
        </div>
      )}
      {/* Conditionally render the Add Receiver Details button if the supplier's ERP name is pending and the receipt date is not pending */}
      {supplier.erpName.toLowerCase() === "pending" &&
        supplier.receiptDate.toLowerCase() !== "pending" && (
          <div>
            <Button
              size="small"
              variant="contained"
              sx={{
                padding: "10px 20px",
                mb: "20px",
                fontSize: "14px",
                backgroundColor: "#c7ab79",
                "&:hover": {
                  backgroundColor: "#c4943f",
                },
                textTransform: "capitalize",
              }}
              onClick={() => handleOpenAddReceiverDetailsModal()}
            >
              Add Receiver Details
            </Button>
            {/* Conditionally render the Add Receiver Details Modal based on its open state */}
            {openAddReceiverDetailsModal && (
              <SampleRequestSampleControlAddReceiverDetailsModal
                open={openAddReceiverDetailsModal}
                setOpen={setOpenAddReceiverDetailsModal}
                handleOpen={handleOpenAddReceiverDetailsModal}
                data={supplier}
                sampleRequestID={sampleRequestID}
                sampleItemID={sampleItemID}
                supplierValues={supplierValues}
                setReloadData={setReloadData}
              />
            )}
          </div>
        )}
      {/* Conditionally render the Add ERP Item Code button if the delivered date is
      not pending */}
      {supplier.deliveredDate !== "pending" && (
        <div>
          <Button
            size="small"
            variant="contained"
            sx={{
              padding: "10px 20px",
              mb: "20px",
              fontSize: "14px",
              backgroundColor: "#c7ab79",
              "&:hover": {
                backgroundColor: "#c4943f",
              },
              textTransform: "capitalize",
            }}
            onClick={handleOpenAddNewItemCodeDialog}
          >
            Add New Item Code
          </Button>
          {/* Conditionally render the Add Receiver Details Modal based on its open state */}
          {openAddReceiverDetailsModal && (
            <SampleRequestSampleControlAddReceiverDetailsModal
              open={openAddReceiverDetailsModal}
              setOpen={setOpenAddReceiverDetailsModal}
              handleOpen={handleOpenAddReceiverDetailsModal}
              data={supplier}
              sampleRequestID={sampleRequestID}
              sampleItemID={sampleItemID}
              supplierValues={supplierValues}
              setReloadData={setReloadData}
            />
          )}
          {openAddNewItemCodeDialog && (
            <AddNewItemERPCodeDialog
              open={openAddNewItemCodeDialog}
              setOpen={setOpenAddNewItemCodeDialog}
              handleOpen={handleOpenAddNewItemCodeDialog}
              sampleRequestID={sampleRequestID}
              sampleItemID={sampleItemID}
              qualityReportsID={supplier.qualityReportsID}
              setReloadData={setReloadData}
            />
          )}
        </div>
      )}
    </div>
  );
}
